import {
  Autocomplete,
  Chip,
  Grid2,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import ChevronDownIco from "../../assets/icons/ChevronDownIco";
import CupIco from "../../assets/icons/CupIco";
import DotsVerticalIco from "../../assets/icons/DotsVerticalIco";
import FavouriteIco from "../../assets/icons/FavouriteIco";
import ResumeIntelligenceNote from "../../assets/icons/ResumeIntelligenceNote";
import CommonButton from "../../component/Button";
import DropDownSelect from "../../component/Select";
import { KlarityChatBotCall } from "../../redux/action/ChatBot";
import AcheivementBar from "./components/AcheivementBar";
import { StyledFlexRowView } from "../common-components/StyledComponents";
import { AcheivementsCard, SelectCreateCard } from "../jobs/style";
import AddMoreCandidate from "../matches/quick-match/components/AddMoreCandidate";
import ShareQuickMatch from "../matches/quick-match/components/ShareQuickMatch";
import KlarityChatBot from "./components/KlarityChatBot";

const dimensionOptions = [
  { name: "Dimension - Client", id: 1 },
  { name: "Dimension - Candidate", id: 2 },
  { name: "Dimension - Recruiter", id: 3 },
];

const achievements = [
  {
    name: "ARR",
    description: "+405K vs plan",
    value: "$20,134,400",
    percentage: 100,
    period: "lastYear",
  },
  {
    name: "Net Profit rate",
    description: "-0.21% vs Plan",
    value: "4.8%",
    percentage: 60,
    period: "lastYear",
  },
  {
    name: "Total Clients",
    description: "+2 vs Plan",
    value: 9,
    percentage: 100,
    period: "lastYear",
  },
  {
    name: "Candidates in Role",
    description: "+3 vs plan",
    value: 88,
    percentage: 100,
    period: "lastYear",
  },
  {
    name: "Conversion %",
    description: "+0.39% vs plan",
    value: "28.8",
    percentage: 100,
    period: "lastYear",
  },
  {
    name: "ARR",
    description: "-50K vs plan",
    value: "$5,023,000",
    percentage: 80,
    period: "lastQuarter",
  },
  {
    name: "Net Profit rate",
    description: "-0.79% vs Plan",
    value: "4.54%",
    percentage: 60,
    period: "lastQuarter",
  },
  {
    name: "Total Clients",
    description: "+ 1 to Plan",
    value: 8,
    percentage: 100,
    period: "lastQuarter",
  },
  {
    name: "Candidates in Role",
    description: "+1 vs plan",
    value: 82,
    percentage: 100,
    period: "lastQuarter",
  },
  {
    name: "Conversion %",
    description: "+0.45% vs plan",
    value: "29.62%",
    percentage: 100,
    period: "lastQuarter",
  },
  {
    name: "ARR",
    description: "+102k vs Plan",
    value: "$1,034,532",
    percentage: 100,
    period: "lastMonth",
  },
  {
    name: "Net Profit rate",
    description: "+0.11% vs Plan",
    value: "4.91%",
    percentage: 100,
    period: "lastMonth",
  },
  {
    name: "Total Clients",
    description: "On Plan",
    value: 7,
    percentage: 100,
    period: "lastMonth",
  },
  {
    name: "Candidates in Role",
    description: "+1 vs plan",
    value: 82,
    percentage: 100,
    period: "lastMonth",
  },
  {
    name: "Conversion %",
    description: "-0.09% vs plan",
    value: "25%",
    percentage: 80,
    period: "lastMonth",
  },
];

const execSummary = [
  {
    name: "No. of Contractors",
    value: 21,
  },
  {
    name: "Billable Hours",
    description: ["Average of 2009 per contractor"],
    value: "42,189",
    achieved: false,
  },
  {
    name: "Total Revenue",
    description: ["+1.1% vs Last Year"],
    value: "$ 4,440,814.14",
    achieved: true,
  },
  {
    name: "Gross Profit",
    description: ["+0.3% vs Last Quarter"],
    value: "$ 232,698.66",
    achieved: true,
  },
  {
    name: "Net Profit Rate",
    description: ["-0.43% vs Last Year"],
    value: "5.24 %",
    achieved: false,
  },
  {
    name: "Avg. Time to Fill",
    description: ["-1.2 days vs portfolio"],
    value: "4.3",
    subChar: "Days",
    achieved: false,
  },
];

const execSummaryCandidate = [
  {
    name: "Contractor Billable hours",
    description: ["vs portfolio average of 2043"],
    value: "1990",
    achieved: false,
  },
  {
    name: "Revenue per placement",
    // description: ["20.5% more than last quarter"],
    value: "$245,844.60 ",
  },
  {
    name: "Cost/Expense",
    // description: ["+1.1% more than last quarter"],
    value: "$ 231,093.92",
    // achieved: true,
  },
  {
    name: "Client Satisfaction score/NPS",
    description: ["Lower than portfolio average"],
    value: " 4.1",
    subChar: "Stars",
    achieved: false,
  },
  {
    name: "Average Tenure (Career)",
    value: 1.53,
    subChar: "Yrs/Client",
  },
  {
    name: "Time on Bench (Career)",
    value: "6.60%",
  },
];

const execSummaryRecruiter = [
  {
    name: "Time To Fill",
    value: "7.2",
    subChar: "days",
  },
  {
    name: "Average quality of top Candidates",
    value: "64.32%",
  },
  {
    name: "Offer/Contract Rate",
    value: "12.39%",
  },
  {
    name: "Candidate Survey NPS",
    value: "4.3",
    subChar: "Stars",
  },
  {
    name: "Recruiter Activity Index",
    value: "6.2",
    subChar: "per Job",
  },
  {
    name: "Recruiter Cost per Hire",
    value: "6071.43",
  },
  {
    name: "Revenue generated",
    value: "$ 6,348,160.00",
  },
  {
    name: "Candidates placed",
    value: "28",
  },
  {
    name: "Number of Jobs worked on",
    value: "45",
  },
];

const ReportDashBoard = () => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [ai, setAi] = useState(false);
  const [selectedDimension, setSelectedDimension] = useState(
    dimensionOptions[0]
  );
  const [isBottomVisible, setIsBottomVisible] = useState(false);
  const [selectedClient, setSelectedClient] = useState("Best Buy");
  const aiSectionRef = useRef(null);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const handleShareDialogClose = () => setShareDialogOpen(false);
  const [addMoreCandidateDialogOpen, setAddMoreCandidateDialogOpen] =
    useState(false);
  const [addMoreCandidateFiles, setAddMoreCandidateFiles] = useState([]);
  const [selectedMetric, setSelectedMetric] = useState("Last Year");
  const [isClicked, setIsClicked] = React.useState(false);
  const dispatch = useDispatch();

  const handleButtonClick = () => {
    setIsClicked(!isClicked);
  };

  const handleImportDataClick = () => {
    // setAnchorEl(null); // Close menu
    setAddMoreCandidateDialogOpen(true); // Open AddMoreCandidate dialog
  };
  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const commonFileValidationCheck = (
    commonFiles,
    allowedTypes,
    setCommonFiles,
    existingFiles
  ) => {
    const validFiles = [];
    const invalidFiles = [];

    commonFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push({
          file,
          name: file.name,
          size: `${(file.size / 1024).toFixed(1)} KB`,
          type: file.type,
          progress: 0,
          buffer: 0,
          visible: false,
          delete: true,
          message: "",
        });
      } else {
        invalidFiles.push(file.name);
      }
    });

    const mergedFiles = [
      ...existingFiles,
      ...validFiles.filter(
        (newFile) =>
          !existingFiles.some(
            (existingFile) => existingFile.name === newFile.name
          )
      ),
    ];
    setCommonFiles(mergedFiles);

    if (invalidFiles.length > 0) {
    }
  };
  const handleAddMoreCandidateFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(
      selectedFiles,
      allowedTypes,
      setAddMoreCandidateFiles,
      addMoreCandidateFiles
    );
  };

  const handleShareInvite = () => {
    alert("Invite Sent!");
    setShareDialogOpen(false);
  };

  // const dimensionOptions = [
  //   "Dimension - Client",
  //   "Dimension - Candidate",
  //   "Dimension - Recruiter",
  // ];
  // const dimensionOptions = [
  //   { name: "Dimension - Client", id: 1 },
  //   { name: "Dimension - Candidate", id: 2 },
  //   { name: "Dimension - Recruiter", id: 3 },
  // ];

  const clientOptions = ["Best Buy", "Macy's", "Target"];

  // const clientMapping = {
  //   "Dimension - Client": [
  //     "Best Buy",
  //     "Target",
  //     "AT&T",
  //     "NRG",
  //     "Macys",
  //     "Mayo Clinic",
  //     "JCPenny",
  //   ],
  //   "Dimension - Candidate": ["Wendy", "Karthik", "Harini", "Rohit", "Rinal"],
  //   "Dimension - Recruiter": ["Olivia Rhye", "Lana Steiner", "Kate Morrison"],
  // };
  // const filteredClientOptions = clientMapping[selectedDimension] || [
  //   "Best Buy",
  //   "Target",
  //   "AT&T",
  //   "NRG",
  //   "Macys",
  //   "Mayo Clinic",
  //   "JCPenny",
  // ];

  // useEffect(() => {
  //   const filteredClients = clientMapping[selectedDimension] || [];
  //   if (filteredClients.length > 0) {
  //     setSelectedClient(
  //       selectedDimension === "Dimension - Recruiter"
  //         ? filteredClients[2]
  //         : filteredClients[0]
  //     );
  //   } else {
  //     setSelectedClient("Best Buy");
  //   }
  // }, [selectedDimension]);

  const clientMapping = {
    "Dimension - Client": [
      { name: "Best Buy" },
      { name: "Target" },
      { name: "AT&T" },
      { name: "NRG" },
      { name: "Macys" },
      { name: "Mayo Clinic" },
      { name: "JCPenny" },
    ],
    "Dimension - Candidate": [
      { name: "Wendy" },
      { name: "Karthik" },
      { name: "Harini" },
      { name: "Rohit" },
      { name: "Rinal" },
    ],
    "Dimension - Recruiter": [
      { name: "Olivia Rhye" },
      { name: "Lana Steiner" },
      { name: "Kate Morrison" },
    ],
  };

  const filteredClientOptions = clientMapping[selectedDimension.name] || [];

  useEffect(() => {
    const filteredClients = clientMapping[selectedDimension.name] || [];
    if (filteredClients.length > 0) {
      setSelectedClient(
        selectedDimension.name === "Dimension - Recruiter"
          ? filteredClients[2]?.name
          : filteredClients[0]?.name
      );
    } else {
      setSelectedClient("Best Buy");
    }
  }, [selectedDimension]);

  const successMetricsOptions = ["Last Year", "Last Quarter", "Last Month"];

  const getExecSummaryData = () => {
    switch (selectedDimension?.name) {
      case "Dimension - Candidate":
        return execSummaryCandidate;
      case "Dimension - Recruiter":
        return execSummaryRecruiter;
      case "Dimension - Client":
      default:
        return execSummary;
    }
  };

  const getAchievementData = () => {
    switch (selectedMetric) {
      case "Last Year":
        return achievements.filter((item) => item.period === "lastYear");
      case "Last Quarter":
        return achievements.filter((item) => item.period === "lastQuarter");
      case "Last Month":
        return achievements.filter((item) => item.period === "lastMonth");
      default:
        return achievements;
    }
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleMenuClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const scrollToAiSection = () => {
    aiSectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const DEFAULT_PDF_URL = "/reports/QBR-BestBuy.pdf";
  const downloadPDF = () => {
    const link = document.createElement("a");
    link.href = DEFAULT_PDF_URL;
    link.download = "QBR-BestBuy.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const [chatBotData, setChatBotData] = useState({
    message: [],
    value: "",
    loader: false,
    pageLoader: false,
  });

  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;
    let payload = {
      query: chatBotData.value,
    };

    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],
      loader: true,
      value: "",
    }));

    try {
      const data = await KlarityChatBotCall(payload);
      console.log(data, "sfkjshfjkfskjsf");
      const botResponse = {
        sender: "bot",
        text: data?.data?.answer ? data?.data?.answer : data?.data?.analysis,
        visualizations: data?.data?.visualizations,
        reasoning: data?.data?.reasoning,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: "Failed" || error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
    }
  };

  const handleChatBotChange = (event) => {
    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  return (
    <Grid2 container spacing={4} fontFamily={"Inter"} padding={"2rem"}>
      <Grid2 item size={{ xs: 12 }} container spacing={1}>
        <Grid2 item size={{ xs: 5 }}>
          <Typography variant="h2">Klarity insights</Typography>
        </Grid2>
        <Grid2
          item
          size={{ xs: 12, md: 7 }}
          justifyContent={"end"}
          container
          spacing={2}
        >
          <CommonButton
            variant="outlined"
            color="#344054"
            border="#D0D5DD"
            fontWeight="600"
            value="See Visualization"
            disabled
          />
          <CommonButton
            variant="outlined"
            color="#344054"
            border="#D0D5DD"
            fontWeight="600"
            value="Get Help"
            onClick={scrollToAiSection}
          />{" "}
          <CommonButton
            hoverBackground={"white"}
            value={<FavouriteIco color={isClicked ? "#7F56D9" : "#eaecf0"} />}
            padding={"10px 14px"}
            variant="outlined"
            color={"#344054"}
            border={"#D0D5DD"}
            fontWeight={"600"}
            aria-haspopup="true"
            minWidth={"20px !important"}
            onClick={handleButtonClick}
          />
        </Grid2>
        <Grid2 item size={{ xs: 12 }}>
          <Typography variant="h6">
            All your data, insights and opportunity to drive impact
          </Typography>
        </Grid2>
      </Grid2>
      <Grid2 item size={{ xs: 12 }} container spacing={3}>
        <Grid2 item size={{ xs: 12 }} container spacing={1}>
          <Grid2 item size={{ xs: 5 }}>
            <StyledFlexRowView>
              <CupIco />
              <Typography
                fontSize={"20px"}
                fontWeight={600}
                color={"#101828"}
                display={"flex"}
                alignItems={"center"}
                variant="h5"
              >
                Success Metrics
              </Typography>
            </StyledFlexRowView>
          </Grid2>
          <Grid2
            item
            size={{ xs: 12, md: 7 }}
            justifyContent={"end"}
            container
            spacing={2}
          >
            <Autocomplete
              disablePortal
              options={successMetricsOptions}
              value={selectedMetric}
              disableClearable
              onChange={(event, newValue) => setSelectedMetric(newValue)}
              sx={{
                "& .MuiAutocomplete-inputRoot": {
                  padding: "5px",
                  border: "1px solid #D0D5DD",
                  alignItems: "center",
                  borderRadius: "8px",
                  backgroundColor: "#FFFFFF",
                  minWidth: "180px",
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#667085",
                  opacity: 1,
                  fontSize: "16px",
                  fontWeight: 400,
                },
              }}
              renderInput={(params) => (
                <TextField {...params} fullWidth variant="outlined" />
              )}
              popupIcon={
                <IconButton sx={{ padding: 0 }}>
                  <ChevronDownIco />
                </IconButton>
              }
            />
          </Grid2>
        </Grid2>
        <Grid2 item size={{ xs: 12 }} container spacing={2}>
          {getAchievementData().map(
            ({ name, value, description, million, percentage }, index) => (
              <Grid2
                item
                size={{ xs: 12, sm: 12, md: 6, lg: 2.4 }}
                key={name + index}
              >
                <AcheivementsCard
                  gap={"0.6rem"}
                  key={name + index}
                  padding={"1rem 0.8rem"}
                >
                  <Typography color="#5B738B" variant="subtitle">
                    {name}
                  </Typography>
                  <Typography variant="h5">
                    {value ?? ""}
                    {million && (
                      <Typography
                        color="grey"
                        variant="subtitle"
                        fontSize={"0.8rem"}
                      >
                        {"\u00A0"} million
                      </Typography>
                    )}
                  </Typography>
                  <AcheivementBar percentage={percentage} />
                  <StyledFlexRowView style={{ height: 20 }}>
                    <Typography variant="subtitle">{description}</Typography>
                  </StyledFlexRowView>
                </AcheivementsCard>
              </Grid2>
            )
          )}
        </Grid2>
      </Grid2>
      <Grid2 item size={{ xs: 12 }} container spacing={3}>
        <Grid2 item size={{ xs: 12 }} container spacing={1}>
          <Grid2 item size={{ xs: 5 }}>
            <StyledFlexRowView>
              <ResumeIntelligenceNote />
              <Typography
                fontSize={"20px"}
                fontWeight={600}
                color={"#101828"}
                display={"flex"}
                alignItems={"center"}
                variant="h5"
              >
                Exec Summary
              </Typography>
            </StyledFlexRowView>
          </Grid2>
          <Grid2
            item
            size={{ xs: 12, md: 7 }}
            justifyContent={"end"}
            container
            spacing={2}
          >
            {/* <DropDownSelect
              marginTop="0px"
              removeAnimation={true}
              value={selectedDimension}
              data={dimensionOptions}
              handleChange={(event) => setSelectedDimension(event.target.value)}
            /> */}

            <StyledFlexRowView>
              <DropDownSelect
                // sx={{ width: "100%" }}
                customStyle={{ minWidth: "250px", marginRight: "12px" }}
                marginTop="0px"
                removeAnimation={true}
                value={selectedDimension.name} // Ensure value is a string
                data={dimensionOptions}
                handleChange={(event) => {
                  const selected = dimensionOptions.find(
                    (item) => item.name === event.target.value
                  );
                  setSelectedDimension(selected || dimensionOptions[0]);
                }}
              />

              <DropDownSelect
                customStyle={{ minWidth: "250px" }}
                marginTop="0px"
                removeAnimation={true}
                value={selectedClient}
                data={filteredClientOptions}
                handleChange={(event) => setSelectedClient(event.target.value)}
              />
            </StyledFlexRowView>

            <CommonButton
              hoverBackground={"white"}
              value={<DotsVerticalIco />}
              padding={"10px 14px"}
              variant="outlined"
              color={"#344054"}
              border={"#D0D5DD"}
              fontWeight={"600"}
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleMenuClick}
              minWidth={"30px !important"}
            />
          </Grid2>
        </Grid2>
        <Grid2 item size={{ xs: 12 }} container spacing={2}>
          {getExecSummaryData().map(
            ({ name, value, description, achieved, subChar }, index) => (
              <Grid2
                item
                size={{ xs: 12, sm: 12, md: 6, lg: 4 }}
                key={name + index}
              >
                <SelectCreateCard>
                  <Typography color="#5B738B" variant="subtitle">
                    {name}
                  </Typography>
                  <Typography variant="h5" color="#38414A">
                    {value ?? "25"}
                    {subChar && (
                      <Typography
                        color="#5B738B"
                        variant="subtitle"
                        fontSize={"0.8rem"}
                      >
                        {"\u00A0"} {subChar}
                      </Typography>
                    )}
                  </Typography>
                  <StyledFlexRowView style={{ height: 20 }}>
                    {description?.map((label) => (
                      <Chip
                        label={label}
                        sx={{
                          color: achieved ? "#188918" : "#5B738B",
                          bgcolor: achieved && "#E9FFCE",
                          borderRadius: "3px",
                          width: "fit-content",
                          px: 1,
                        }}
                      />
                    ))}
                  </StyledFlexRowView>
                </SelectCreateCard>
              </Grid2>
            )
          )}
        </Grid2>
      </Grid2>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={() => setShareDialogOpen(true)}>Share</MenuItem>
        <MenuItem onClick={downloadPDF}>Create exec report/QBR</MenuItem>
        <MenuItem onClick={handleImportDataClick}>Import Data </MenuItem>
      </Menu>

      <Grid2 item size={{ xs: 12 }} ref={aiSectionRef}>
        <SelectCreateCard key={"ask_ai"}>
          {/* {ai && (
            <img
              src={Ai}
              alt="AI Suggestions"
              style={{ width: "100%", height: "auto" }}
            />
          )}
          <Grid2 item size={{ xs: 12 }}>
            <CommonTextField
              border={"0.5px solid #EAECF0"}
              padding={15}
              placeholder={"Ask anything.."}
              bgColor={"#F7F8F9"}
              endComponent={
                <CommonButton
                  onClick={() => setAi(!ai)}
                  fontWeight={600}
                  padding={"8px 25px"}
                  value={"Ask AI"}
                  endIcon={<AutoAwesomeIcon />}
                />
              }
            />
          </Grid2> */}
          <KlarityChatBot
            chatBotData={chatBotData}
            handleSendMessage={handleSendMessage}
            isBottomVisible={isBottomVisible}
            setIsBottomVisible={setIsBottomVisible}
            handleChatBotChange={handleChatBotChange}
          />
        </SelectCreateCard>
      </Grid2>

      <ShareQuickMatch
        title="Share Exec Summary"
        shareDialogOpen={shareDialogOpen}
        handleShareDialogClose={handleShareDialogClose}
        handleShareInvite={handleShareInvite}
      />
      <AddMoreCandidate
        addMoreCandidateDialogOpen={addMoreCandidateDialogOpen}
        handleAddMoreCandidateDialogClose={() =>
          setAddMoreCandidateDialogOpen(false)
        }
        handleAddMoreCandidateClick={() => setAddMoreCandidateDialogOpen(false)}
        handleAddMoreCandidateFileUpload={handleAddMoreCandidateFileUpload}
        title="Upload Business Data"
      />
    </Grid2>
  );
};

export default ReportDashBoard;
